/**
 * rateLimitMessage.js — Message lisible pour une réponse 429 (10.5.300).
 *
 * Pourquoi : l'apiLimiter (200 requêtes / 15 min par utilisateur) renvoyait
 * jusqu'ici « Erreur serveur (429) », qui laisse croire à une panne. Le
 * backend expose RateLimit-Reset (secondes avant la réouverture, en-têtes
 * standard draft-6 d'express-rate-limit) : on en tire le délai quand il est là.
 */
import i18n from '../i18n'; // singleton (pattern util→i18n, cf. pdfHelpers)

export const isRateLimited = (res) => res?.status === 429;

export function rateLimitMessage(res) {
  const resetSeconds = Number(res?.headers?.get?.('RateLimit-Reset'));
  if (Number.isFinite(resetSeconds) && resetSeconds > 0) {
    return i18n.t('common.rateLimitedIn', { minutes: Math.ceil(resetSeconds / 60) });
  }
  return i18n.t('common.rateLimited');
}
